import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { log3DModuleErrorMessage } from '../../utils/warnings';

var Options3d =
/*#__PURE__*/
function (_Component) {
  _inherits(Options3d, _Component);

  function Options3d(props) {
    var _this;

    _classCallCheck(this, Options3d);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Options3d).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "update3dOptions", function () {
      var _this$props = _this.props,
          alpha = _this$props.alpha,
          axisLabelPosition = _this$props.axisLabelPosition,
          beta = _this$props.beta,
          depth = _this$props.depth,
          fitToPlot = _this$props.fitToPlot,
          frame = _this$props.frame,
          viewDistance = _this$props.viewDistance,
          getChart = _this$props.getChart;
      var opts = {
        chart: {
          options3d: {
            enabled: true,
            alpha: alpha,
            axisLabelPosition: axisLabelPosition,
            beta: beta,
            depth: depth,
            fitToPlot: fitToPlot,
            frame: frame,
            viewDistance: viewDistance
          }
        }
      };
      var chart = getChart();
      chart.update(opts, true);
    });

    if (process.env.NODE_ENV === 'development') {
      if (!props.getHighcharts().ZAxis) log3DModuleErrorMessage();
    }

    return _this;
  }

  _createClass(Options3d, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update3dOptions();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update3dOptions();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Options3d;
}(Component);

_defineProperty(Options3d, "defaultProps", {
  enabled: false,
  alpha: 0,
  beta: 0,
  depth: 100,
  fitToPlot: true,
  viewDistance: 25,
  axisLabelPosition: 'default',
  frame: {
    visible: 'default',
    size: 1,
    bottom: {},
    top: {},
    left: {},
    right: {},
    back: {},
    front: {}
  }
});

export default Options3d;